import React, { Component } from "react";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import PrintIcon from "@material-ui/icons/Print";
import Button from "@mui/material/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import FetchServerData from "../../../provider/FetchServerData";
import givBeeLogo from "../../../assets/img/givbeeLogo.png";
import store from "../../../redux/store";
import ReactToPrint from "react-to-print";
import Utils from "../../../provider/Utils";
class BillingReceipt extends Component {
  header = store.getState().header.header;
  constructor(props) {
    super(props);
    this.state = {
      receipt: null,
      isOverages: false,
      open: false,
    };
  }

  showReceiptDetails(rowData) {
    const postObject = {
      header: this.header,
      payment: { id: rowData.id },
    };
    FetchServerData.callPostService("/billingms/getReceiptData", postObject)
      .then((output) => {
        let receiptDetails = output.data.receipt;
        if (output.status === "SUCCESS") {
          this.setState({
            render: true,
            open: true,
            receipt: receiptDetails,
            isOverages: rowData?.isOverages,
            action: "view",
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleClose() {
    this.setState({ open: false });
  }

  // downloadReceiptAsImage = () => {
  //   if (this.imageDwlRef.current) {
  //     html2canvas(this.imageDwlRef.current).then((canvas) => {
  //       const link = document.createElement("a");
  //       link.href = canvas.toDataURL("image/jpeg"); // Change to "image/png" if needed
  //       link.download = "receipt.jpg"; // Change extension if downloading PNG
  //       link.click();
  //     });
  //   }
  // };
  downloadReceiptAsPDF = () => {
    if (this.imageDwlRef.current) {
      // this.imageDwlRef.current.style.width = "8.5in";
      // this.imageDwlRef.current.style.height = "11in";
      const opt = {
        margin: [0.5, 0.5], // inches (top/bottom, left/right)
        filename: "receipt.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      };

      html2pdf().set(opt).from(this.imageDwlRef.current).save();
    }
  };

  handlePrint = () => {
    if (this.receiptRef.current) {
      html2canvas(this.receiptRef.current).then((canvas) => {
        const imageData = canvas.toDataURL("image/png");
        const printWindow = window.open("", "_blank");

        printWindow.document.write(`
          <html>
            <head>
              <title>Print Receipt</title>
              <style>
                body { text-align: center; margin: 0; padding: 20px; }
                img { max-width: 100%; }
              </style>
            </head>
            <body>
              <img src="${imageData}" />
              <script>
                window.onload = function() {
                  window.print();
                  window.onafterprint = function() { window.close(); };
                };
              </script>
            </body>
          </html>
        `);

        printWindow.document.close();
      });
    }
  };

  render() {
    this.printComponentRef = React.createRef();
    this.imageDwlRef = React.createRef();
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="receiptDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff", fontWeight: "600" }}>Receipt</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div
              md={12}
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
                padding: "0.5em",
              }}
            >
              <div className="row pt-0 p-2 justify-content-end">
                {/* <div className="col-sm-12 p-2 pt-0 text-end d-flex"> */}
                <Button
                  id="downloadReportButton"
                  variant="contained"
                  type="button"
                  startIcon={
                    <i
                      className="fa fa-download"
                      style={{ fontSize: "16px" }}
                    ></i>
                  }
                  onClick={this.downloadReceiptAsPDF}
                >
                  Download Receipt
                </Button>
                &nbsp; &nbsp;
                <ReactToPrint
                  trigger={
                    () => (
                      <Button
                        id="ptsHollowButton"
                        variant="contained"
                        type="button"
                        style={{ width: "80px" }}
                        startIcon={<PrintIcon />}
                      // onClick={(e) => this.printContent(e)}
                      >
                        Print
                      </Button>
                    )
                    // <Button>Print this out!</Button>
                  }
                  content={() => this.printComponentRef}
                />
                {/* </div> */}
              </div>
              <div
                ref={(el) => (this.printComponentRef = el)}
                className="print-container"
              >
                <div
                  ref={this.imageDwlRef}
                  // style={{
                  //   fontFamily: "Arial, sans-serif",
                  //   width: "520px",
                  //   maxWidth: "520px",
                  //   // background: "#f3efef",
                  //   // border: "2px solid #ddd",
                  //   // borderRadius: "8px",
                  //   // boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  //   padding: "10px",
                  //   margin: "auto",
                  // }}
                  style={{
                    // width: "8.5in",
                    // height: "11in",
                    backgroundColor: "white",
                    padding: "50px",
                    boxSizing: "border-box",
                    border: "1px solid",
                  }}
                >
                  <div className="row d-flex">
                    <div className="col-md-6 align-self-end">
                      <strong className="mb-0 fs-4">Payment Receipt</strong>
                    </div>
                    <div className="col-md-6" style={{ textAlign: "right" }}>
                      <div style={{ width: "100%" }}>
                        <img
                          style={{
                            maxWidth: "160px",
                            maxHeight: "160px",
                            display: "block",
                            marginLeft: "auto",
                          }}
                          src={givBeeLogo}
                          alt="Logo"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 fs-6" style={{ lineHeight: "1.8" }}>
                    <div className="row">
                      <div className="col-md-3 fs-6">Account:</div>
                      <div className="col-md-9 fs-6">
                        <strong>{this.state.receipt?.accountName}</strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 fs-6">Account Admin:</div>
                      <div className="col-md-9 fs-6">
                        <strong>{this.state.receipt?.userName}</strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 fs-6">Billing Date:</div>
                      <div className="col-md-9 fs-6">
                        <strong>{this.state.receipt?.billingDate}</strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 fs-6">Plan/Type:</div>{" "}
                      <div className="col-md-9 fs-6">
                        <strong>
                          {this.state.receipt?.businessDomainName}
                        </strong>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-md-3 fs-6">Transaction ID:</div>{" "}
                      <div className="col-md-9 fs-6">
                        <strong>{this.state.receipt?.transactionId}</strong>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 fs-6">Name on Card:</div>
                      <div className="col-md-9 fs-6">
                        <strong>{this.state.receipt?.cardName}</strong>
                      </div>
                    </div>
                    {this.state.isOverages ?
                      <div className="row">
                        <div className="col-md-3 fs-6">Credits Used:</div>
                        <div className="col-md-9 fs-6">
                          <strong>{`${Utils.formatWithCommas(
                            this.state.receipt?.overageCredits
                          )}`}</strong>
                        </div>
                      </div>
                      :
                      <div className="row">
                        <div className="col-md-3 fs-6">Plan Fee:</div>
                        <div className="col-md-9 fs-6">
                          <strong>{Utils.formatWithCommas(this.state.receipt?.paidAmount)}</strong>
                        </div>
                      </div>
                    }
                    <div className="row">
                      <div className="col-md-3 fs-6">Details:</div>
                      <div className="col-md-9 fs-6">
                        <strong>
                          {this.state.receipt?.overageDescription}
                        </strong>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-3 fs-6">Amount Paid:</div>
                      <div className="col-md-9 fs-6">
                        <strong>
                          {`${Utils.formatWithCommas(
                            this.state.receipt?.paidAmount
                          )}`}
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ height: "480px" }}>
                    <div className="col-sm-12 align-self-end">
                      <p
                        style={{
                          fontSize: "12px",
                          margin: "0px",
                          color: "#353538 ",
                          fontWeight: "500",
                        }}
                      >
                        Subscription and related fees are charged to the
                        primary6+ credit card on file. The card will be charged
                        each billing period for the current term of the
                        subscription. SMS overages (if shown) represent those
                        accrued during the prior billing period.
                        <br />
                        <br />
                        Please do not reply to this email. It is an automated
                        notification and is unable to receive replies.
                        <br />
                        GivBee, LLC., www.givbee.com
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}

export default BillingReceipt;
